import React, { useEffect, useCallback, useMemo, memo } from 'react';
import { useForm } from 'react-hook-form';
import { FlexControllerV2 } from 'components/FlexControllerInput/V2';
import { Button, Col } from 'reactstrap';
import ServiceCRUDChatTS from 'services/ServiceCRUDCHATTS';
import { useState } from 'react';
import { toast } from 'react-toastify';

const redistributionStrategyService = new ServiceCRUDChatTS('/configurations/type-of-redistribution-after-login');

export const RedistributionStrategy = memo(() => {
  const { control, reset, errors, handleSubmit } = useForm()
  const [options, setOptions] = useState([])

  const onSubmit = useCallback((data) => {
    // eslint-disable-next-line no-unused-expressions
    redistributionStrategyService?.put?.('', { typeOfRedistribution: data?.typeOfRedistribution?.value ?? "" })
      .then(() => toast.success("Atualização feita com sucesso!"))
  }, [])

  useEffect(() => {
    // Busca todas as opções disponíveis
    redistributionStrategyService.get('/all')
      .then(res => setOptions(res.data?.data ?? []))
      .catch((err) => {
        console.log(err)
        toast.error("Não foi possível buscar as estratégias de redistribuição após login em filas de chat", { autoClose: 3000, closeOnClick: true })
      })
  }, [])

  useEffect(() => {
    // Evita fetches desnecessários
    if (!options.length) return

    // Busca a opção atual selecionada
    redistributionStrategyService.get('')
      .then(res => (reset({ typeOfRedistribution: options.find(opt => opt.value === res.data?.data?.typeOfRedistribution) })))
      .catch((err) => {
        console.log(err)
        toast.error("Não foi possível buscar a estratégia de redistribuição após login em filas de chat atual", { autoClose: 3000, closeOnClick: true })
      })
  }, [options])

  return <Col sm="6">
    <form onSubmit={handleSubmit(onSubmit)}>
      <FlexControllerV2
        type="select"
        name="typeOfRedistribution"
        control={control}
        label="Selecione a estratégia desejada"
        options={options}
        errors={errors}
        rules={{ required: 'Campo obrigatório' }}
      />
      <Button
        color="success"
        type="submit"
        className="mt-4"
      >
        Salvar
    </Button>
    </form></Col>
});


